import Button from "atoms/buttons/button";
import React from "react";
import ShareSpacePanelAtom from "utilities/atoms/bookview/share-space-panel-atom";
import { useAtom } from "jotai";
import { useLocalization } from "utilities/hooks/use-localization";

interface ShareSpaceSubmitButtonProps {
    onClick: () => void;
}

const CSS_BASE_CLASSNAME = "c-share-space-submit-button";

const ShareSpaceSubmitButton: React.FC<ShareSpaceSubmitButtonProps> = ({
    onClick,
}) => {
    const { t } = useLocalization();

    const [sharePanelAtom] = useAtom(ShareSpacePanelAtom);

    const buttonText =
        sharePanelAtom.getShareItemsLength() < 1
            ? t("share")
            : sharePanelAtom.getShareItemsLength() === 1
              ? t("shareItem__singular")
              : t("shareItems__plural", {
                    count: sharePanelAtom.getShareItemsLength(),
                });

    const shareDisabled =
        sharePanelAtom.getShareItemsLength() === 0 ||
        sharePanelAtom.getShareItemsLength() === undefined;

    return (
        <Button
            cssClassName={CSS_BASE_CLASSNAME}
            onClick={onClick}
            disabled={shareDisabled}>
            {buttonText}
        </Button>
    );
};
export default ShareSpaceSubmitButton;
